export function focusHeadingAndSetTitle(node: HTMLElement | null) {
  if (!node) return

  const previousTitle = document.title
  document.title = `${node.textContent} - ${previousTitle}`
  node.focus()

  return () => {
    document.title = previousTitle
  }
}
